import type { CatalogItem } from '@/services/catalog'

export type CatalogKpis = {
  total: number
  active: number
  inactive: number
}

export function computeCatalogKpis(items: CatalogItem[]): CatalogKpis {
  let active = 0
  let inactive = 0
  for (const item of items) {
    if (item.isActive) active += 1
    else inactive += 1
  }
  return { total: items.length, active, inactive }
}
